import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import collaboratorEventAPI from '@infrastructure/collaborator-event-api';
export const createCollaboratorEventAsync = createAsyncThunk('collaboratorEvent/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorEventAPI.createCollaboratorEvent(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCollaboratorEventAsync = createAsyncThunk('collaboratorEvent/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorEventAPI.updateCollaboratorEvent(payload.id, payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCollaboratorEventByIdAsync = createAsyncThunk('collaboratorEvent/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorEventAPI.getCollaboratorEventById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCollaboratorEventsAsync = createAsyncThunk('collaboratorEvent/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await collaboratorEventAPI.getAllCollaboratorEvents();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCollaboratorEventAsync = createAsyncThunk('collaboratorEvent/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorEventAPI.deleteCollaboratorEvent(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
